"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";

type NavBarLinkProps<RouteInferType> = {
  setOnClick?: () => void;
  className?: string;
  title: string;
  link: __next_route_internal_types__.RouteImpl<RouteInferType>;
  linkClassName?: string;
};

export function NavbarLinkHighlightable<RouteInferType>({
  setOnClick,
  className,
  title,
  link,
  linkClassName,
}: NavBarLinkProps<RouteInferType>) {
  const pathname = usePathname() ?? "";
  // match /${lng}$ (homepage) and /${lng/ (everything else)
  const linkWithoutLocale = link.replace(/\/(de|es|en)(\/|$)/, "/");
  const pathWithoutLocale = pathname.replace(/\/(de|es|en)(\/|$)/, "/");

  const isCurrentPath = linkWithoutLocale.endsWith("/")
    ? pathWithoutLocale.endsWith("/")
      ? pathWithoutLocale === linkWithoutLocale
      : `${pathWithoutLocale}/` === linkWithoutLocale
    : pathWithoutLocale === linkWithoutLocale;

  return (
    <div key={`navbar-${title}`} className={cn("navBlockItem mx-3", className)}>
      <Link
        href={link}
        rel="noreferrer noopener"
        className={cn(
          "block-field",
          linkClassName,
          isCurrentPath && "text-matchbus",
        )}
        onClick={setOnClick}
      >
        {title}
      </Link>
    </div>
  );
}
